module.exports = __webpack_public_path__ + "static/media/loveseat.18c598f2.svg";